<script setup lang="ts">
import BaseModal from './BaseModal.vue';
import gettext from 'src/utils/gettext';
import { useRouter } from 'vue-router';

const router = useRouter();
const { $gettext } = gettext;

const emit = defineEmits(['closeModal']);

const handleRedirectToPayments = async (): Promise<void> => {
  await router.push({ name: 'subscription-payments' });
  emit('closeModal');
};
</script>
<template>
  <BaseModal :set-border="true" @close="$emit('closeModal')">
    <template #header>
      <h4>
        {{ $gettext('Neuhrazená objednávka') }}
      </h4>
    </template>
    <template #body>
      <div class="header-limit_wrapper">
        <h4 class="q-mt-md header-limit_wrapper--header text-center">
          <q-icon
            class="fa-solid fa-circle-exclamation"
            :style="{ marginRight: '0.5rem', fontSize: '3rem' }"
          />
          {{ $gettext('Máte neuhrazenou objednávku za pronájem aplikace!') }}
        </h4>
        <p class="header-limit_wrapper--content text-center q-ma-none">
          <b>{{ $gettext('Prosíme o její úhradu co nejdříve.') }}</b>
          <br />
          {{
            $gettext(
              'V případě neuhrazení může dojít k dočasnému zablokování Vašeho účtu.'
            )
          }}
        </p>
      </div>
    </template>
    <template #footer>
      <div class="bottom-action-buttons">
        <q-btn
          :label="$gettext('Zavřít')"
          class="btn"
          color="grey-12"
          text-color="dark-300"
          unelevated
          ripple
          @click.prevent="$emit('closeModal')"
        />
        <q-btn
          :label="$gettext('Uhradit')"
          class="q-ml-md btn"
          color="primary"
          unelevated
          ripple
          @click="handleRedirectToPayments"
        />
      </div>
    </template>
  </BaseModal>
</template>
<style lang="scss" scoped>
.header-limit_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $dark-300;
  &--header {
    font-weight: 700;
    color: $error;
    margin-bottom: 2rem;
  }
}

.bottom-action-buttons {
  justify-content: center;
}
</style>
